import { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import useUsers from "../../../hooks/useUsers";
import { handleLoadSelectOptions, mapValues } from "../../../util/Utilities";
import useServices from "../../../hooks/useServices";
import useAxios from "../../../hooks/useAxios";
import { useFeedBack } from "../../../context/FeedBackContext";
import { useNavigate } from "react-router-dom";

const AcquisitionUserCreate = () => {

    const { setCustomAlert } = useFeedBack();

    const navigate = useNavigate();

    const [servicesFilters, setServicesFilters] = useState({ perPage: 500, name: '' });

    const [checkAll, setCheckAll] = useState(false);

    const [{ users, loading: usersLoading }, getUsers] = useUsers({ params: { perPage: 50 } }, { useCache: false });

    const [{ services }, getServices] = useServices({ params: servicesFilters }, { useCache: false });

    const [{ loading: storeLoading }, store] = useAxios({ url: `/acquisition-users`, method: 'POST' }, { manual: true, useCache: false });

    const [data, setData] = useState({
        user_document_number: '',
        service_ids: []
    });

    useEffect(() => {

        let values = [];

        if (checkAll) values = services?.map((service) => `${service?.id}`);

        setData((oldData) => {
            return {
                ...oldData,
                service_ids: values
            }
        })
    }, [checkAll])

    const handleChange = (e) => {

        var value = e.target.value

        if (e.target.type === 'checkbox') {
            if (data?.[e.target.name]?.includes(value)) {
                value = data?.[e.target.name]?.filter((values) => values != value);
            } else {
                value = [...data?.[e.target.name], value];
            }
        }

        setData((oldData) => {
            return {
                ...oldData,
                [e.target.name]: value
            }
        });
    }

    const handleSubmit = (e) => {
        e?.preventDefault?.();

        store({ data }).then(() => {
            setCustomAlert({
                title: '¡Operacion Exitosa!',
                severity: 'success',
                message: `El registro fue creado exitosamente.`,
                show: true
            });
            navigate?.(`/responsables/adquisiciones/listar`);
        });
    }

    return (
        <div className="card">
            <div className="card-header">
                <h3 className="card-title">
                    Crear responsable de adquisiciones
                </h3>
            </div>
            <form className="card-body" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12 mb-3">
                        <p className="text-center text-black">
                            Seleccione el usuario
                        </p>
                        <AsyncSelect
                            isClearable
                            onFocus={() => { getUsers() }}
                            isLoading={usersLoading}
                            defaultOptions={mapValues(users, 'documentNumber')}
                            name="user_document_number"
                            loadOptions={(e) => handleLoadSelectOptions(e, getUsers, null, 'documentNumber')}
                            placeholder='Escriba el nombre para buscar...'
                            onChange={(e) => { handleChange({ target: { value: e.value, name: 'user_document_number' } }) }}
                        />
                    </div>
                    <div className="col-md-12 mb-3">
                        <p className="text-center text-black">
                            Seleccione los servicios
                        </p>
                        <input type="text" name="name" placeholder="Buscar..." className="form-control mb-3" value={servicesFilters?.name} onChange={(e) => {
                            setServicesFilters((old) => {
                                return {
                                    ...old,
                                    [e.target.name]: e.target.value
                                }
                            })
                        }} />
                        <div className="row">
                            <div className="col-md-4 mb-2">
                                <div className="d-flex align-items-center justify-content-between border-bottom border-primary">
                                    <label htmlFor={`checkbox-services-check-all`} className="mb-0" style={{ cursor: 'pointer' }}>
                                        SELECCIONAR TODOS
                                    </label>
                                    <input
                                        style={{ cursor: 'pointer' }}
                                        id={`checkbox-services-check-all`}
                                        type="checkbox"
                                        onChange={() => {
                                            setCheckAll((old) => !old)
                                        }}
                                        checked={checkAll}
                                    />
                                </div>
                            </div>
                            {services?.map((service) => {
                                return (
                                    <div className="col-md-4 mb-2">
                                        <div className="d-flex align-items-center justify-content-between border-bottom border-primary">
                                            <label htmlFor={`checkbox-services-${service?.id}`} className="mb-0" style={{ cursor: 'pointer' }}>
                                                {service?.name}
                                            </label>
                                            <input
                                                style={{ cursor: 'pointer' }}
                                                id={`checkbox-services-${service?.id}`}
                                                type="checkbox"
                                                onChange={handleChange}
                                                name="service_ids"
                                                value={`${service?.id}`}
                                                checked={data?.service_ids?.includes(`${service?.id}`)}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="col-md-12">
                        <button className="btn btn-primary w-100" disabled={storeLoading}>
                            {
                                storeLoading ?
                                    'Cargando'
                                    :
                                    'Guardar cambios'
                            }
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default AcquisitionUserCreate;